import React from 'react';

import useStyles from './styles';

import { FormattedDataItem } from '../../types';
import ListItem from '../ListItem';

interface Props {
    data: FormattedDataItem[];
    className?: string;
}

const List: React.FC<Props> = ({ data, className }) => {
    const { classes, cx } = useStyles();
    return (
        <div className={cx(classes.root, className)}>
            {data.map((data, index) => (
                <ListItem key={index} data={data} />
            ))}
        </div>
    );
};
export default List;
